import type { StoreWithPersist } from '@plug-core/state'

export const syncStore = async (store: StoreWithPersist<any>) => {
  if (!store.persist) return

  const { name } = store.persist.getOptions()
  
  // For web, just rehydrate from localStorage without listening to changes
  // since we're in a single context (no background/popup separation)
  store.persist.rehydrate()
  
  // Optionally listen to storage events for cross-tab sync
  const handleStorageChange = (e: StorageEvent) => {
    if (e.key === name && e.storageArea === localStorage) {
      store.persist.rehydrate()
    }
  }
  
  window.addEventListener('storage', handleStorageChange)
  
  // Return cleanup function
  return () => window.removeEventListener('storage', handleStorageChange)
}